import React from 'react';
import PropTypes from 'prop-types';
import {RichContent, Heading, Member} from '../elements';

export const MemberComponent = (props) => {
  const {content} = props;
  return (
    <section className="col-12 kiwi-members">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            {content.heading && <Heading content={content.heading} size="h2"/> }
          </div>
          <div className="col-xs-12">
            {content.description && <RichContent dangerous={content.description } />}
          </div>
        </div>
        <div className="row">
          <ul className="members__list list-unstyled">
          {content.members.map((member, i) => {
            return <Member key={i}
                          icon={member.icon.url}
                          header={member.header}
                          description={member.description}
            />
          })}
          </ul>
        </div>
      </div>
    </section>
  )

};

MemberComponent.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  members: PropTypes.array
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/components/MemberComponent.js